<template>
  <main>
    <v-app-bar
      app
      color="white"
      class="main-app-bar"
      dark
      flat
    >
      <router-link
        id="app-bar-home-button"
        :to="{name: 'landing'}"
      >
        <span style="color:black"> <img
          width="200"
          :src="AppBarLogo"
        > </span>
      </router-link>
      <v-spacer />
      <v-btn
        v-if="$vuetify.breakpoint.smAndUp"
        id="app-bar-contact-us"
        :to="{
          name: 'contactUs'
        }"
      >
        Contact Us
      </v-btn>
      <v-menu
        v-if="!$vuetify.breakpoint.smAndUp"
        offset-y
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            icon
            color="primary"
            v-bind="attrs"
            v-on="on"
          >
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item :to="{
            name: 'contactUs'
          }">
            <v-list-item-title>
              Contact Us
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>

    <div style="flex: 1; display: flex; flex-direction: column;">
      <router-view @snackbar="(val) => $emit('snackbar', val)" />
    </div>
    <v-footer
      class="footer"
    >
      <div class="footer-content">
        <v-row
          justify="space-between"
          align="end"
        >
          <v-col cols="4">
            <v-row
              wrap
            >
              <v-col cols="12">
                <h3> About </h3>
              </v-col>
              <v-col
                cols="12"
              >
                <router-link
                  id="footer-contact-us"
                  class="footer-button"
                  :to="{name:'contactUs'}"
                >
                  Contact Us
                </router-link>
              </v-col>
              <v-col cols="12">
                <a
                  id="footer-privacy"
                  class="footer-button"
                  href="https://www.castandcrew.com/privacy-policy/"
                  target="_blank"
                >
                  Privacy Policy
                </a>
              </v-col>
              <v-col cols="12">
                <a
                  id="footer-privacy"
                  class="footer-button"
                  href="https://www.castandcrew.com/terms-of-use/"
                  target="_blank"
                >
                  Terms of Use
                </a>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="4" />
          <v-col cols="auto">
            <div>&copy; {{ new Date().getFullYear() }}</div>
          </v-col>
        </v-row>
      </div>
    </v-footer>
  </main>
</template>

<script>
import AppBarLogo from '../assets/logo-long.svg';

export default {
  name: 'App',

  data: () => ({
    AppBarLogo,
  }),
};
</script>

<style scoped lang="scss">
  @import '@/scss/design';

  main {
    min-height: 100%;
    display: flex;
    flex-direction: column;
  }

  #app-bar-contact-us {
    text-transform: unset;
    color: #06679D;
    background: #CDEDFF;
    font-size: 18px;
    letter-spacing: normal;
    box-shadow: none;
    border-radius: 4px;
    height: 42px;
    padding: 12px;
    margin: 10px;
    font-weight: 400;
  }

  // .main-app-bar {
  //   padding: 4px 60px;
  // }

  .date-row {
    border-bottom: 1px solid $gray-light;
  }

  .footer {
    margin: 0 60px;
    color: white;
    font-size: 14px;
    transition: margin 0.15s ease;
    background: none;
    padding: 0;
    justify-content: center;

  }
  .footer-content {
    background: linear-gradient(79.29deg, #0671D3 -24.23%, #86C9E6 176.73%);
    // max-width: 1400px;
    border-radius: 20px 20px 0px 0px;
    padding: 20px 20px 40px 20px;
    width: 100%;
  }
  .footer .col {
    padding: 2px 0;
  }
  .footer .row {
    margin: 0;
  }
  .footer-button {
    text-decoration: none;
    color:white;
    padding: 2px 0;
  }
  @media screen and (max-width: 960px) {
    .footer {
      margin: 0 20px;
    }

  // .main-app-bar {
  //   padding: 4px 20px;
  // }
  }
</style>
